// hooks/useAtualizarDados.ts
import { useState } from "react";
import { numberPadrao } from "../../../uteis/formatPhoneNumber";
// --------------------- Import Services ---------------------
import { cadastrarUsuarioService } from "../../../services/cadastrarUsuarioService";
import { cadastrarRepresentante } from "../../../services/cadastrarRepresentanteService";
import { cadastrarEnderecoService } from "../../../services/cadastrarEnderecoService";

export const useAdicionarRepresentante = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<boolean | null>(null);
  const [success, setSuccess] = useState<boolean | null>(null);
  const resetError = () => setError(null);

  const adicionarRepre = async (
    representanteData: any,
    usuarioData: any,
    cotaUsuarioId: number
  ) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    const dataUsuario: any = {
      ...usuarioData,
      celular: numberPadrao(usuarioData.celular),
    };
    const enderecoData: any = {
      endereco: usuarioData.endereco,
      complemento: usuarioData.complemento,
      cidadeId: usuarioData.cidadeId,
      estadoId: usuarioData.estadoId,
      paisId: usuarioData.paisId,
    };

    const representanteDataNovo: any = {
      ...representanteData,
      cotaUsuarioId: cotaUsuarioId,
    };

    try {
      const adicionarUsuario = await cadastrarUsuarioService(dataUsuario);

      // Adicionando o id do usuário ao objeto existente
      if (adicionarUsuario) {
        enderecoData.usuarioId = adicionarUsuario.id;
        representanteDataNovo.usuarioId = adicionarUsuario.id;
      }
      const adicionarEndereco = await cadastrarEnderecoService(enderecoData);
      const adicionarRepresentante = await cadastrarRepresentante(
        representanteDataNovo
      );
      if (adicionarUsuario && adicionarRepresentante && adicionarEndereco) {
        setSuccess(true);
        setError(false);
      } else {
        setError(true);
        setSuccess(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return { adicionarRepre, isLoading, isSuccess, error, success, resetError };
};
